import { Component } from '@angular/core';

@Component({
    selector: 'skeleton-item',
    template: '',
    styleUrls: ['./skeleton-item.component.scss'],
    standalone: false
})
export class SkeletonItemComponent {}
